var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-between"},[_c('NavSearch'),_vm._v(" "),_c('BaseButton',{staticClass:"mx-[14px]",attrs:{"label":"Login","variant":"secondaryDark"}}),_vm._v(" "),_c('BaseButton',{attrs:{"label":"Book a Demo"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }